<template>
    <v-main :style="{background: 'white', height:'90vh'}">
        <v-container style="height:100%;">
            <h2 class="pa-2" style=""> {{$t('privacyPolicy')}}</h2><br>
            <div class="pa-2" style=" height:80%;">
                <HLLegalFrame kind="privacy_policy"/>
            </div>
            <div v-if="mustShowAcceptButton" class="pa-2">
                <v-btn color="primary" @click="acceptPrivacyPolicy">Accept Privacy Policy</v-btn>
            </div>
        </v-container>
    </v-main>
</template>

<script>
import HLLegalFrame from '@/components/ui/HLLegalFrame.vue'
// import CONFIG from "../../constants/config";

export default {
    components: {
        HLLegalFrame
    },
    computed: {
        /**
         * Returns true if the accept button should be shown
         */
        mustShowAcceptButton() {
            return false;
            // const storedPrivacyVersion = localStorage.getItem('privacyVersion');
            // const currentPrivacyVersion = CONFIG.VUE_APP_PRIVACY_VERSION;
            // return storedPrivacyVersion !== currentPrivacyVersion;
        }
    },
    methods: {
        acceptPrivacyPolicy() {
            localStorage.setItem('privacyVersion', process.env.VUE_APP_PRIVACY_VERSION);
            const redirectPath = this.$route.query.redirect || '/';
            this.$router.push(redirectPath);
        }
    }
}
</script>

<style scoped>
a{
    overflow-wrap: break-word;
}
.containerText{
    max-width: 70%;
}
.subTitle { font-weight:bold; }
table {
    border-collapse: collapse;
    width: 100%;
}
td, th {
    border: 1px solid #000000;
    text-align: left;
}
</style>
